import { useMutation, useQueryClient } from 'react-query'
import toast from 'react-hot-toast'
import { nfdVerifyConfirm } from 'api/api-client'

export const verifyConfirm = async (id: string, challenge: string) => {
  const { data } = await nfdVerifyConfirm(id, { challenge })

  return data
}

type UseVerifyConfirm = {
  loading: string
  success: string
  error: string
}

export default function useVerifyConfirm(options: UseVerifyConfirm) {
  const queryClient = useQueryClient()

  return useMutation(
    ({ id, challenge }: { id: string; challenge: string }) => {
      return verifyConfirm(id, challenge)
    },
    {
      onMutate: () => {
        const toastId = toast.loading(options.loading)

        return { toastId }
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onSuccess: (_data, _variables, context: any) => {
        toast.success(options.success, {
          id: context.toastId,
          duration: 5000 // 5 seconds
        })

        return queryClient.invalidateQueries(['name'])
      },
      onError: (_error, _variables, _context) => {
        return queryClient.invalidateQueries(['name'])
      }
    }
  )
}
